import React, { useState, useEffect } from 'react';
import { instagramPosts } from '../mock';
import { Instagram, Heart, MessageCircle, ExternalLink } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        console.log('Fetching Instagram posts from:', `${API}/instagram/posts`);
        const response = await axios.get(`${API}/instagram/posts?limit=6`, {
          timeout: 10000
        });
        console.log('Instagram API response:', response.data);
        
        if (response.data && response.data.posts && response.data.posts.length > 0) {
          setPosts(response.data.posts);
          console.log('✅ Loaded', response.data.posts.length, 'Instagram posts');
        } else {
          console.warn('No Instagram posts found, using mock data');
          setPosts(instagramPosts);
        }
      } catch (error) {
        console.error('Failed to fetch Instagram posts:', error);
        console.log('Using mock Instagram data as fallback');
        // Fallback to mock data if API fails
        setPosts(instagramPosts);
      } finally {
        setLoading(false);
      }
    };
    
    fetchInstagramPosts();
  }, []);
  const formatCount = (count) => {
    if (count >= 1000) {
      return (count / 1000).toFixed(1) + 'k';
    }
    return count;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 space-y-4">
          <div className="flex items-center justify-center gap-3">
            <Instagram size={40} className="text-[#dc143c]" />
            <h2 className="text-5xl md:text-6xl font-bold text-[#1a1a2e] tracking-tight">
              Follow Us
            </h2>
          </div>
          <p className="text-lg text-[#666] max-w-2xl mx-auto">
            Stay updated with our latest collections and offers on Instagram @bhargavashoesbti
          </p>
          <a
            href="https://instagram.com/bhargavashoesbti"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-3 rounded-sm text-base font-medium hover:from-purple-700 hover:to-pink-700 transition-all duration-300"
          >
            <Instagram size={20} />
            <span>Follow on Instagram</span>
            <ExternalLink size={16} />
          </a>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <p className="text-lg text-[#666]">Loading Instagram posts...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => (
            <div
              key={post.id}
              className="group bg-[#f7f5f2] rounded-sm overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={post.media_url}
                  alt="Instagram post"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 right-4 flex items-center gap-4 text-white">
                    <div className="flex items-center gap-2">
                      <Heart size={18} className="fill-white" />
                      <span className="text-sm font-medium">{formatCount(post.like_count)}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <MessageCircle size={18} />
                      <span className="text-sm font-medium">{formatCount(post.comments_count)}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-4 space-y-3">
                <p className="text-sm text-[#666] line-clamp-2 leading-relaxed">
                  {post.caption}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-[#666] tracking-wider uppercase">
                    {formatDate(post.timestamp)}
                  </span>
                  <a
                    href={post.permalink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-[#dc143c] hover:text-[#b01030] font-medium tracking-wider uppercase transition-colors duration-300"
                  >
                    View Post →
                  </a>
                </div>
              </div>
            </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default InstagramFeed;
